import HttpClientRecoveryPassword from '../services/HttpClientPassword';
import { APP_URL, RECOVERY, CHANGE_PASSWORD } from '../constants'

export const recoveryPost = (body, dispatch) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };

        HttpClientRecoveryPassword.post(`${APP_URL}${RECOVERY}`, body)
        .then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
}

export const updatePasswordUser = (body, token) => {

    return new Promise((resolve, reject) => {
        const configuration = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };

        HttpClientRecoveryPassword.put(`${APP_URL}${CHANGE_PASSWORD}`, body, configuration).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response)
        })
    })
}